import {
    ONLY_ABC_PATHS,
    ONLY_DELPHI_PATHS,
    PATH_SETS
} from 'src/constants/constants';
import { CommonUtils } from 'src/utility/commonUtils';

// This is a helper class to sort the paths into sets.
export class PathSortingUtil {

    /**
     * Takes in the current path and identify the SET in which this path falls.
     * One path must only fall into 1 set.
     * ONLY_DELPHI: Only Delphi widget will be surfaced
     * ONLY_ABC: Only ABC widget will be surfaced
     * WEBLAB_SWITCH: Delphi(T1) or ABC(Control/Default) widget will be surfaced based on weblab treatment.
     * @param path
     */
    public static resolvePathSet(path: string): PATH_SETS {
        // Avoiding the NO_FOOTER path as it is handled separately to add lazy loading.
        if (CommonUtils.isPathPresent(path, ONLY_DELPHI_PATHS)) {
            return PATH_SETS.ONLY_DELPHI
        }
        else if (CommonUtils.isPathPresent(path, ONLY_ABC_PATHS)) {
            return PATH_SETS.ONLY_ABC
        }
        else {
            return PATH_SETS.WEBLAB_SWITCH
        }
    }

}
